<div class="todoapp stack-large">

<table style="width: 100%"><tr><td>
<span style="font-size: 10px"><a href="../../">Back to Home</a></span>
<br><br>
</td>
<td>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<!--
-->
<img style="height: 80px; display: none" id="topLogo" src="../../image/catsluck.jpg">
<img style="height: 80px" src="{CoinLogoURL}">
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</td>
<td>
<!-- GTranslate: https://gtranslate.io/ -->
<a href="#" onclick="doGTranslate('en|en');return false;" title="English" class="gflag nturl" style="background-position:-0px -0px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="English" /></a><a href="#" onclick="doGTranslate('en|fr');return false;" title="French" class="gflag nturl" style="background-position:-200px -100px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="French" /></a><a href="#" onclick="doGTranslate('en|de');return false;" title="German" class="gflag nturl" style="background-position:-300px -100px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="German" /></a><a href="#" onclick="doGTranslate('en|it');return false;" title="Italian" class="gflag nturl" style="background-position:-600px -100px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="Italian" /></a><a href="#" onclick="doGTranslate('en|pt');return false;" title="Portuguese" class="gflag nturl" style="background-position:-300px -200px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="Portuguese" /></a><a href="#" onclick="doGTranslate('en|ru');return false;" title="Russian" class="gflag nturl" style="background-position:-500px -200px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="Russian" /></a><a href="#" onclick="doGTranslate('en|es');return false;" title="Spanish" class="gflag nturl" style="background-position:-600px -200px;"><img src="//gtranslate.net/flags/blank.png" height="16" width="16" alt="Spanish" /></a>
<div id="google_translate_element2"></div>
<br><br>
</td></tr>
</table>

<h3 style="text-align: center"><a target="_blank"
 href="https://smartscan.cash/address/{CoinAddress}">{Symbol}</a> Pool</h3>

<div>
  <TabBar tabs={['BUY', 'POOL', 'FAQ']} let:tab bind:active>
    <Tab {tab} >
      <Label><span style="font-size: 20px">{tab}</span></Label>
    </Tab>
  </TabBar>
</div>

{#if active=='BUY'}
<div>
  <p><b style="font-size: 14px">Multiplier:</b>&nbsp;&nbsp;<Textfield bind:value={Multiplier} label=""  on:input={()=>(syncValues(true))}
  style="width: 130px"></Textfield>&nbsp;(1.05~1000)<br>
  <span style="color: grey; font-size: 16px">If you win, the coins paid by you will be multiplied by this value and returned to you.</span></p>

  <p>When the multiplier equals {Multiplier}, the maximum amount you can buy is {MaxAmount}, and your chance to win is {Chance}%.

  <p><b style="font-size: 14px">Amount:</b> &nbsp;&nbsp;<Textfield bind:value={Amount} label="" on:input={()=>(syncValues(true))}
  style="width: 130px"></Textfield><span style="color:red">{AmountWarn}</span><br>
  <span style="color: grey; font-size: 16px">How many {Symbol} do you want to paid for this lottery ticket?</span></p>
  
  <p>The fee you paid for this lottery is {FeeAmount}{Symbol}. If you win, the reward is {RewardAmount}{Symbol}.</p>

  {#if CoinIsCashCats}
  <p>After buying this lottery, you can get {Amount} CATSUP.</p>
  {/if}

  <Button on:click={buy} variant="outlined">
    <Label style="font-size: 18px">Buy Lottery!</Label>
  </Button>

  <hr>

  <p><Select bind:value={FilterMethod} on:click={onFilterMethodChange} label="Show Lotteries from">
      <Option value="All">All Addresses</Option>
      <Option value="Mine">My Addresses</Option>
      <Option value="Specified">A Specified Address</Option>
  </Select></p>

  <p>
  <Button on:click={()=>(OpenRecCountDlg=true)} variant="outlined">
    <Label style="font-size: 18px">Show at most {RecCountLimit} records</Label>
  </Button>
  </p>

  <p>
  <Button on:click={showAndUpdateHistoryTable} variant="outlined">
    <Label style="font-size: 18px"><img style="width: 15px; height: auto; vertical-align: sub" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB3aWR0aD0iMTc5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYzOSAxMDU2cTAgNS0xIDctNjQgMjY4LTI2OCA0MzQuNXQtNDc4IDE2Ni41cS0xNDYgMC0yODIuNS01NXQtMjQzLjUtMTU3bC0xMjkgMTI5cS0xOSAxOS00NSAxOXQtNDUtMTktMTktNDV2LTQ0OHEwLTI2IDE5LTQ1dDQ1LTE5aDQ0OHEyNiAwIDQ1IDE5dDE5IDQ1LTE5IDQ1bC0xMzcgMTM3cTcxIDY2IDE2MSAxMDJ0MTg3IDM2cTEzNCAwIDI1MC02NXQxODYtMTc5cTExLTE3IDUzLTExNyA4LTIzIDMwLTIzaDE5MnExMyAwIDIyLjUgOS41dDkuNSAyMi41em0yNS04MDB2NDQ4cTAgMjYtMTkgNDV0LTQ1IDE5aC00NDhxLTI2IDAtNDUtMTl0LTE5LTQ1IDE5LTQ1bDEzOC0xMzhxLTE0OC0xMzctMzQ5LTEzNy0xMzQgMC0yNTAgNjV0LTE4NiAxNzlxLTExIDE3LTUzIDExNy04IDIzLTMwIDIzaC0xOTlxLTEzIDAtMjIuNS05LjV0LTkuNS0yMi41di03cTY1LTI2OCAyNzAtNDM0LjV0NDgwLTE2Ni41cTE0NiAwIDI4NCA1NS41dDI0NSAxNTYuNWwxMzAtMTI5cTE5LTE5IDQ1LTE5dDQ1IDE5IDE5IDQ1eiIvPjwvc3ZnPg==">&nbsp;Refresh</Label>
  </Button>
  </p>

  {#if FilterMethod != "All"}
    <p>Addr: {SpecifiedAddr}</p>
    <p>Total Won / Total Bought = {TotalWon} / {TotalBought} = {ROI}%</p>
  {/if}

  {#if ShowHistoryTable}
    <table>
    <tr><th>Time</th><th>Balance</th><th>Multiplier</th><th>txid</th></tr>
    {#each HistoryEntries as entry (entry.id)}
      <tr><td>{entry.timeStr}</td>
      {#if entry.isWin}
        {#if entry.multiplier < 3 && entry.amount >= TotalCoins*0.01*0.425}
           <td class="neonText" style="font-weight: bold">+{entry.amount}</td><td>{entry.multiplier}</td>
        {:else if entry.multiplier >= 3 && entry.amount >= TotalCoins*0.01*0.85}
           <td class="neonText" style="font-weight: bold">+{entry.amount}</td><td>{entry.multiplier}</td>
        {:else}
           <td style="color: green">+{entry.amount}</td><td>{entry.multiplier}</td>
        {/if}
      {:else if entry.isBuy}
        <td style="color: red">-{entry.amount}</td><td>{entry.multiplier}</td>
      {/if}
      <td><a target="_blank" href="https://smartscan.cash/transaction/{entry.transactionHash}">view</a></td></tr>
    {/each}
    </table>
  {/if}
</div>
{/if}
 
{#if active=='POOL'}
<div>
  <p>Current address: {SignerAddr}</p>
  <p>You can deposit {Symbol} into this lottery pool and earn fees. But if lottery buyers win their rewards, you will suffer some loss together with the pool.</p>
  <p>Now the lottery pool has {TotalShare} shares and each share equals {CoinPerShare}{Symbol} (totally {TotalCoins}{Symbol}). You have {UserShare} shares in the pool (equaling {UserCoins}{Symbol}). You can get more share by depositing {Symbol} into the pool, and your shares will be burnt after withdrawing from the pool.<br>
Your shares can be transferred to others as an SEP20 token <a target="_blank"
 href="https://smartscan.cash/address/{PoolAddress}">clk{Symbol}.</a>
Please let your wallet <a href="#" on:click|preventDefault={watchClkToken}>watch clk{Symbol}</a>.
</p>

  <p> 
  <Button on:click={()=>(OpenDepositDlg=true)} variant="outlined">
    <Label style="font-size: 18px">Deposit</Label>
  </Button>
  </p>

  <p>
  <Button on:click={()=>(OpenWithdrawDlg=true)} variant="outlined">
    <Label style="font-size: 18px">Withdraw</Label>
  </Button>
  </p>

  <p>
  <Button on:click={showPoolHistory} variant="outlined">
    <Label style="font-size: 18px">Show My <span style="color: blue">Deposits(+)</span> and <span style="color: purple">Withdraws(-)</Label>
  </Button>
  </p>

  {#if ShowPoolTable}
  <table><tr><th>Time</th><th>{Symbol}</th><th>txid</th></tr>
    {#each PoolHisEntries as entry}
      <tr><td>{entry.timeStr}</td>
      {#if entry.isDeposit}
        <td style="color: blue">+{entry.amount}</td>
      {:else if entry.isWithdraw}
        <td style="color: purple">-{entry.amount}</td>
      {/if}
      <td>&nbsp;<a target="_blank" href="https://smartscan.cash/transaction/{entry.transactionHash}">view</a></td></tr>
    {/each}
  </table>
  <!--
  <p>Your total earnings: {TotalEarning}{Symbol}.</p>
  -->
  {/if}
</div>
{/if}
 
{#if active=='FAQ'}
<div>
  <!-- Debug buttons
  <Button on:click={()=>(deployToken("CATS"))} variant="outlined">
    <Label style="font-size: 18px">DeployCATS</Label>
  </Button>
  <Button on:click={()=>(deployToken("CLK"))} variant="outlined">
    <Label style="font-size: 18px">DeployCLK</Label>
  </Button>
  <Button on:click={deployGov} variant="outlined">
    <Label style="font-size: 18px">DeployGov</Label>
  </Button>
  <Button on:click={deployCatsUp} variant="outlined">
    <Label style="font-size: 18px">DeployCatsUp</Label>
  </Button>
  <Button on:click={deployFactory} variant="outlined">
    <Label style="font-size: 18px">DeployFactory</Label>
  </Button>
  <Button on:click={createCatsPool} variant="outlined">
    <Label style="font-size: 18px">CreateCatsPool</Label>
  </Button>
  <Button on:click={createBchPool} variant="outlined">
    <Label style="font-size: 18px">CreateBchPool</Label>
  </Button>
  <Button on:click={createFlexusdPool} variant="outlined">
    <Label style="font-size: 18px">CreateFlexusdPool</Label>
  </Button>
  <Button on:click={showTwoNameAndSymbol} variant="outlined">
    <Label style="font-size: 18px">showTwoNameAndSymbol</Label>
  </Button>
  <Button on:click={setMinter} variant="outlined">
    <Label style="font-size: 18px">setMinter</Label>
  </Button>
  -->

    <p><b>Who's behind Catsluck?</b></p>
    <p>We are supporters of <a target="_blank" href="https://cashcats.org">cashcats</a>. People often ask what can we do with $CATS? So catsluck was born. You can bet and invest with $CATS now.</p>

    <p><b>Can I get reward as a referer?</b></p>
    <p>Yes. Please send some catsluck.com URLs containing your ReferID to potential players. If a player click the URLs and start to bet with a token, then in his lifetime 0.25% of the token he ever pays for catsluck lotteries will be rewarded to you.</p>
    {#if ReferID!=0}
    <p>You have already registered as a referer. Your ReferID is {ReferID}. Please send one of the following URLs to potential players:<br>
    <a target="_blank" href="https://catsluck.com/?r={ReferID}">https://catsluck.com/?r={ReferID}</a><br>
    <a target="_blank" href="https://catsluck.com/pool/cats?r={ReferID}">https://catsluck.com/pool/cats?r={ReferID}</a><br>
    <a target="_blank" href="https://catsluck.com/pool/bch?r={ReferID}">https://catsluck.com/pool/bch?r={ReferID}</a><br>
    <a target="_blank" href="https://catsluck.com/pool/token?c={Symbol.replace('$','')}&r={ReferID}">https://catsluck.com/pool/token?c={Symbol.replace('$','')}&r={ReferID}</a><br>
    In this pool, you have accumulated {ReferReward}{Symbol} reward. Please <a href="#" on:click|preventDefault={getRefererReward}>click here</a> to get the reward.
    </p>
    {:else}
    <p>Please <a href="#" on:click|preventDefault={registerAsReferer}>register as a referer</a> to get a ReferID.</p>
    {/if}

    {#if !CoinIsCLK}
    <p><b>How to buy back CLK for burning?</b></p>
    <p>Every time someone bets, 0.5% of the betting {Symbol} is accumulated for buyback auction.</p>
    {#if DuringAuction}
      <p>Currently, a Dutch auction is running. You can <a href="#" on:click|preventDefault={endAuction}>end the auction</a> by paying {ClkOfAuction} CLK to get {CoinOfAuction}{Symbol} now (price={PriceOfAuction}). The CLK paid by you will be burnt by the smart contract.</p>
    {:else}
      <p>There have been {CoinReadyForAuction}{Symbol} accumulated for a Dutch auction. You can <a href="#" on:click|preventDefault={startAuction}>send a transaction</a> to start the auction, which will sell these {Symbol} in exchange for CLK.</p>
    {/if}
    {:else}
    <p><b>How to buy back CLK for burning?</b></p>
    <p>Every time someone bets, 0.5% of the betting CLK is burnt automatically.</p>
    {/if}

    <p><b>What is CLK?</b></p>
    <p>CLK's address: {ClkAddress}</p>
    <p>CLK is catsluck's exclusive token. CLK is a deflation coin now. Before <b>Tue, 01 Mar 2022 00:00:00 GMT</b>, users could get 1 free CLK every time he betted 1 $CATS. After that, the total amount of CLK does not increase. Till now, there are totally {ClkSupply} CLK in circulation. Please let your wallet <a href="#" on:click|preventDefault={watchCLK}>watch CLK</a>.</p>

    <p><b>Did the development team reserve CLK?</b></p>
    <p>Not at all. Absolutely fair distribution.</p>

    <p><b>What is CATSUP?</b></p>
    <p>CATSUP is token with infinite supply. Its address: {CatsupAddress}</p>
    <p>With the new version of $CATS pool, users can get 1 free CATSUP every time he bets 1 $CATS. There is no end time for minting CATSUP.</p>
    <p>CATSUP will be used as an expandable token for a sub-project, which will go live later.</p>
    <p>Please let your wallet <a href="#" on:click|preventDefault={watchCATSUP}>watch CATSUP</a>.</p>

<!--
    <p><b>What is FUN?</b></p>
    <p>FUN is another token with infinite supply. Its address: {FunAddress}</p>
    <p>If you are a $CATS holder, you can click <a on:click|preventDefault={mintFUN}>here</a> to mint FUN tokens which equal your $CATS balance.</p>
    <p>Please let your wallet <a href="#" on:click|preventDefault={watchFUN}>watch FUN</a>.</p>
-->

    <p><b>What is house edge?</b></p>
    <p>The house edge is 2.5%.</p>
    {#if CoinIsCLK}
    <p>1.75% is allocated to reward pool, 0.5% is burnt, and 0.25% goes to the referers.</p>
    {:else}
    <p>1.75% is allocated to reward pool, 0.5% is used to buy back CLK in circulation for burning, and 0.25% goes to the referers.</p>
    {/if}

    <p><b>Is catsluck open source?</b></p>
    <p>Yes. Check it here <a href="https://github.com/catsluck/catsluck">https://github.com/catsluck/catsluck</a>.</p>

    <p><b>Where can I find help?</b></p>
    <p>Some users set up these channels:</p>
    <p><a target="_blank" href="https://t.me/catsluck_chinese">https://t.me/catsluck_chinese</a></p>
    <p><a target="_blank" href="https://t.me/catsluck_english">https://t.me/catsluck_english</a></p>
    <p>You can try to ask question there. But the lazy developers are not in them.</p>
</div>
{/if}
 
</div>

<Dialog bind:open={OpenWarnDlg}>
  <Title style="margin-left: 30px">Warning</Title>
  <Content style="margin: 30px">{WarnText}</Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenApproveDlg}>
  <Title style="margin-left: 30px">Approve Token</Title>
  <Content style="margin: 30px">{HintText}</Content>
  <Actions>
    <Button on:click={approve}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenCreateDlg}>
  <Title style="margin-left: 30px">Create Lottery Pool for {Symbol}</Title>
  <Content style="margin: 30px">There is no lottery pool for {Symbol}, do you want to create it?</Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button on:click={createPool}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog 
  bind:open={OpenPendingRewardDlg}
  scrimClickAction=""
  escapeKeyAction=""
  aria-labelledby="mandatory-title"
  aria-describedby="mandatory-content"
>
  <Title style="margin-left: 30px">Get Pending Reward</Title>
  <Content style="margin: 30px">You have a pending reward of {PendingRewardAmount}{Symbol}. Please receive it!</Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button on:click={receivePendingReward}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog
  bind:open={OpenWaitDialog}
  scrimClickAction=""
  escapeKeyAction=""
  aria-labelledby="mandatory-title"
  aria-describedby="mandatory-content"
>
  <Title style="margin-left: 30px" id="mandatory-title">Please Wait...</Title>
  <Content id="mandatory-content"
  style="margin: 30px; height: 160px; width: 340px">
    {WaitHintText}
    <br />
    <br />
    <div style="display: flex; justify-content: center">
      <CircularProgress style="height: 64px; width: 64px;" indeterminate />
    </div>
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Dismiss This Dialog</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenAddressDlg}>
  <Title style="margin-left: 30px">Specify an address</Title>
  <Content style="margin: 30px">
      <p>Please specify an address:</p>
      <Textfield bind:value={SpecifiedAddr} style="width: 330px"></Textfield>
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button on:click={showHistoryTableOfAddr}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>
 
<Dialog bind:open={OpenNoRewardDlg}>
  <Title style="margin-left: 30px">☹️ &nbsp;No Reward&nbsp;☹️</Title>
  <Content style="margin: 30px">
    <p>Sorry, you get no reward in this lottery.</p>
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>
 
<Dialog 
bind:open={OpenYesRewardDlg}
  scrimClickAction=""
  escapeKeyAction=""
  aria-labelledby="mandatory-title"
  aria-describedby="mandatory-content"
>
  <Title style="margin-left: 30px">😁&nbsp;You get the Reward!&nbsp;😁</Title>
  <Content style="margin: 30px">
    <p>Congratulations! You get the reward! Please send a transaction to receive it, or you will lose your reward after 256 blocks.</p>
  </Content>
  <Actions>
    <Button on:click={receivePendingReward}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenWithdrawDlg}>
  <Title style="margin-left: 30px">Withdraw</Title>
  <Content style="margin: 30px">
  <span style="font-size: 16px">Please enter the amount of {Symbol} you want to withdraw from this lottery pool:</span><br>
  <Textfield bind:value={WithdrawAmount} label="Withdraw Amount" style="width: 130px"></Textfield><br>
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button>
      <Label style="font-size: 18px" on:click={withdraw}>Withdraw</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenReloadDlg}>
  <Title style="margin-left: 30px">Reload Page</Title>
  <Content style="margin: 30px">Transaction was sent successfully. Now this page must be reloaded to show the latest status. Please read the updated FAQ after page reload.
  </Content>
  <Actions>
    <Button on:click={()=>(location.reload())}>
      <Label style="font-size: 18px">OK</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenDepositDlg}>
  <Title style="margin-left: 30px">Deposit</Title>
  <Content style="margin: 30px">
  Please enter the amount of {Symbol} you want to deposit into this lottery pool:<br>
  <Textfield bind:value={DepositAmount} label="Deposit Amount" style="width: 130px"></Textfield><br>
  After deposit, you must <b>wait for one hour</b> before transferring your shares to others, or withdrawing from pool.
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button>
      <Label style="font-size: 18px" on:click={deposit}>Deposit</Label>
    </Button>
  </Actions>
</Dialog>

<Dialog bind:open={OpenRecCountDlg}>
  <Title style="margin-left: 30px">Change shown records count</Title>
  <Content style="margin: 30px">
  <span style="font-size: 16px">Please enter the upper limit of the shown records (20~500):</span><br>
  <Textfield bind:value={RecCountLimit} label="shown records count" style="width: 150px"></Textfield><br>
  </Content>
  <Actions>
    <Button>
      <Label style="font-size: 18px">Cancel</Label>
    </Button>
    <Button>
      <Label style="font-size: 18px" on:click={changeShownRecCount}>Change</Label>
    </Button>
  </Actions>
</Dialog>

<!-- =========================================== 
-->

<svelte:window on:load="{init}"/>

<script>
import Tab, { Label } from '@smui/tab';
import TabBar from '@smui/tab-bar';
import CircularProgress from '@smui/circular-progress';
import { ethers } from "ethers";
import Button from '@smui/button';
import Textfield from '@smui/textfield';
import Dialog, { Actions } from '@smui/dialog';
import Select, { Option } from '@smui/select';
import Tooltip, {
    Wrapper,
    Title,
    Content,
    Link,
    RichActions,
  } from '@smui/tooltip';
 
const DefaultGasPrice = ethers.BigNumber.from("0x3e63fa64");
const AllOnes = ethers.BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const BchAddress = "0x0000000000000000000000000000000000002711";
const FunAddress = "0xFE2de72a416F79058d682612a3af652Aa7d02555"

const BurnAddress = "0x0000000000000000000000000000000000000001";
const ZeroAddress = "0x0000000000000000000000000000000000000000";

// Constant Addresses TODO
const ClkAddress = "0x659F04F36e90143fCaC202D4BC36C699C078fC98";
const CashcatsAddress = "0x265bD28d79400D55a1665707Fa14A72978FA6043";
const VrfGovAddress = "0x18C51aa3d1F018814716eC2c7C41A20d4FAf023C";
const CatsupAddress = "0xf8507984fe2B86941eAC7fB8FB4a5Fd39A019002";
const FactoryAddress = "0x621b6B032f490c77cE73C3f5EB0f7af4DF9a9C31";

let VrfServers = []

//==================== CATS =======================================
// let CoinAddress = CashcatsAddress;
// let PoolAddress = "0xae1743df0D81b0B6EC57CF2C2CF4861050AC1F54";
// 
// let Symbol = "$CATS";
// let CoinDecimal = 2; //TODO
// let ApprovingAddress = CoinAddress;
// let CoinIsCLK = false; //TODO
// let CoinIsCashCats = true; //TODO
// let DisplayDigits = 2; //TODO

///==================== BCH =======================================

let CoinAddress = BchAddress;
let PoolAddress = "0xa4f3E07c30A4688CA3830165Df19bE61aD5A5d4c"

let Symbol = "BCH";
let CoinDecimal = 18; //TODO
let ApprovingAddress = CoinAddress;
let CoinIsCLK = false; //TODO
let CoinIsCashCats = false; //TODO
let DisplayDigits = 8; //TODO

// ==================== FLEXUSD =======================================
// 
// let CoinAddress = "0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72";
// let PoolAddress = "0x20Df0B8433bE40cc70Bba9537528a189DA026E5F"
// 
// let Symbol = "FLEXUSD";
// let CoinDecimal = 18; //TODO
// let ApprovingAddress = CoinAddress;
// let CoinIsCLK = false; //TODO
// let CoinIsCashCats = false; //TODO
// let DisplayDigits = 4; //TODO
// ====================  =======================================

let CoinLogoURL = "";
const commentAddress = "0x712886a17fD38C75Fb8f5c22DE392aEaFa52a729"
const ShareDecimal = 18
const SmartBCHChainId = 10000; //TODO
const DefaultStartHeight = 4200000;

const Buy = ethers.utils.id("Buy(address,uint256)")
const Win = ethers.utils.id("Win(address,uint256)")
const Deposit = ethers.utils.id("Deposit(address,uint256)")
const Withdraw = ethers.utils.id("Withdraw(address,uint256)")
const Transfer = ethers.utils.id("Transfer(address,address,uint256)")

const ABI = [
"function buyerTickets(address) public view returns (uint)",
"function buybackPoolSize() public view returns (uint)",
"function auctionPrice() public view returns (uint192)",
"function auctionStartTime() public view returns (uint64)",
"function referRewards(address) public view returns (uint)",
"function totalReferReward() public view returns (uint)",
"function getRefererReward() external returns (uint)",
"function deposit(uint amount, uint newLockUntil) payable external",
"function info(address addr) external view returns (uint, uint, uint, uint)",
"function maxWithdrawal(address myAddr) external view returns (uint)",
"function withdraw(uint deltaShare) external",
"function buyLottery(uint amount, uint multiplierX100, address referer) payable external",
"function getLastTicketHeightAndHash() public view returns (uint, uint)",
"function getMyReward(uint rdm, bytes calldata pi) public returns (uint)",
"function startDutchAuction() external ",
"function getAuctionTokensAndPrice() public view returns (uint, uint, uint)",
"function endDutchAuction() external",

"function lockUntil(address) external view returns (uint)",
"function totalSupply() external view returns (uint)",
"function balanceOf(address account) external view returns (uint256)",
]

const ReferBookABI = [
"function registerAsReferer() external returns (uint)",
"function referer2Id(address referer) external view returns (uint)",
"function referers(uint) external view returns (address)",
"function getAllReferers() external view returns (address[] memory result)",
]

const FactoryABI = [
"function getPoolAddress(address coin) public view returns (address)",
"function create(address coin) external",
]

const VrfGovABI = [
"function pubKey() public view returns (bytes)",
]

const Erc20ABI = [
"function approve(address spender, uint256 amount) external returns (bool)",
"function balanceOf(address account) external view returns (uint256)",
"function allowance(address owner, address spender) external view returns (uint256)",
"function symbol() external view returns (string)",
"function name() external view returns (string)",
"function decimals() external view returns (uint8)",
"function totalSupply() external view returns (uint)",
"function mint() external",
]

let active = 'BUY';
let Multiplier = 2;
let MaxAmount = "--";
let Chance = "--";
let Amount = 1;
let AmountWarn = "";
let FeeAmount = "--";
let RewardAmount = "--";
let FilterMethod = "All";
let OldFilterMethod = "All";
let RecCountLimit = 200;
let TotalWon = "--";
let TotalBought = "--";
let ROI = "---";
let SpecifiedAddr = "";
let AddrForHistory = "";
let OnlyMyLottery = false;
let SignerAddr = "--";
let TotalShare = "--";
let CoinPerShare = "--";
let TotalCoins = "--";
let UserShare = "--";
let UserCoins = "--";
let UnlockTime = 0;
let DepositAmount = 1;
let WithdrawAmount = 1;
let TotalEarning = "--";
let WithPoolTable = false;
let ClkSupply = "--";
let LogIdSet = new Set();
let HistoryEntries = [];
let ShowHistoryTable = false;
let PoolHisEntries = [];
let ShowPoolTable = false;

let ReferID = 0;
let ReferReward = 0;

let DuringAuction = false;
let CoinOfAuction = "--";
let ClkOfAuction = "--";
let PriceOfAuction = "--";
let CoinReadyForAuction = 0;

let OpenWarnDlg = false;
let OpenApproveDlg = false;
let HintText = "";
let WarnText = "";
let WaitHintText = "Please wait for the transaction's execution result.";
let OpenWaitDialog = false;
let OpenPendingRewardDlg = false;
let PendingRewardAmount = "--";
let OpenAddressDlg = false;
let OpenNoRewardDlg = false;
let OpenYesRewardDlg = false;
let OpenDepositDlg = false;
let OpenWithdrawDlg = false;
let OpenReloadDlg = false;
let OpenRecCountDlg = false;
let OpenCreateDlg = false;

function detectEthereumProvider({ mustBeMetaMask = false, silent = false, timeout = 3000, } = {}) {
    _validateInputs();
    let handled = false;
    return new Promise((resolve) => {
        if (window.ethereum) {
            handleEthereum();
        }
        else {
            window.addEventListener('ethereum#initialized', handleEthereum, { once: true });
            setTimeout(() => {
                handleEthereum();
            }, timeout);
        }
        function handleEthereum() {
            if (handled) {
                return;
            }
            handled = true;
            window.removeEventListener('ethereum#initialized', handleEthereum);
            const { ethereum } = window;
            if (ethereum && (!mustBeMetaMask || ethereum.isMetaMask)) {
                resolve(ethereum);
            }
            else {
                const message = mustBeMetaMask && ethereum
                    ? 'Non-MetaMask window.ethereum detected.'
                    : 'Unable to detect window.ethereum.';
                !silent && console.error('@metamask/detect-provider:', message);
                resolve(null);
            }
        }
    });
    function _validateInputs() {
        if (typeof mustBeMetaMask !== 'boolean') {
            throw new Error(`@metamask/detect-provider: Expected option 'mustBeMetaMask' to be a boolean.`);
        }
        if (typeof silent !== 'boolean') {
            throw new Error(`@metamask/detect-provider: Expected option 'silent' to be a boolean.`);
        }
        if (typeof timeout !== 'number') {
            throw new Error(`@metamask/detect-provider: Expected option 'timeout' to be a number.`);
        }
    }
}

async function saveReferer(provider) {
	const url = new URL(location.href);
	const referId = url.searchParams.get("r");
	if(!referId) return;
	const oldReferer = localStorage.getItem("referer")
	//console.log("oldReferer", oldReferer, "referId", referId)
	if(oldReferer && oldReferer != ZeroAddress && oldReferer != BurnAddress) return;
	const factoryContract = new ethers.Contract(FactoryAddress, ReferBookABI, provider);
	//console.log("Here1")
	try {
		const referer = await factoryContract.referers(referId)
		//console.log("oldReferer", oldReferer, "referId", referId, referer)
		localStorage.setItem("referer", referer)
	} catch(e) {
		//console.log("Cannot get referer", e)
	}
}

async function showNameAndSymbol(poolAddress) {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const poolContract = new ethers.Contract(poolAddress, Erc20ABI, provider)
	console.log(await poolContract.name())
	console.log(await poolContract.symbol())
}
async function fillCoinInfo(provider) {
	const url = new URL(location.href);
	//console.log("url.pathname", url.pathname)
	if(url.pathname.endsWith("/cats") || url.pathname.endsWith("/cats/") || url.pathname.endsWith("/cats/index.html")) {
		CoinAddress = CashcatsAddress;
		PoolAddress = "0x9343763BF4092a825564fB3D14DC0ab2dbFB1e16";
		Symbol = "$CATS";
		CoinDecimal = 2;
		ApprovingAddress = CoinAddress;
		CoinIsCLK = false;
		CoinIsCashCats = true;
		DisplayDigits = 2;
		CoinLogoURL = "../../image/"+Symbol.replace('$', 'CASH')+".png"
		return true;
	} else if(url.pathname.endsWith("/bch") || url.pathname.endsWith("/bch/") || url.pathname.endsWith("/bch/index.html")) {
		//Do nothing
		CoinLogoURL = "../../image/"+Symbol.replace('$', 'CASH')+".png"
		return true;
	} else if(url.pathname.endsWith("/flexusd") || url.pathname.endsWith("/flexusd/") || url.pathname.endsWith("/flexusd/index.html")) {
		CoinAddress = "0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72";
		PoolAddress = "0xB936A3858CC3766C5de38C80A769423db6d5B857"
		
		Symbol = "FLEXUSD";
		CoinDecimal = 18;
		ApprovingAddress = CoinAddress;
		CoinIsCLK = false;
		CoinIsCashCats = false;
		DisplayDigits = 4;
		CoinLogoURL = "../../image/"+Symbol.replace('$', 'CASH')+".png"
		return true;
	} else if(url.pathname.endsWith("/law") || url.pathname.endsWith("/law/") || url.pathname.endsWith("/law/index.html")) {
		CoinAddress = "0x0b00366fBF7037E9d75E4A569ab27dAB84759302";
		PoolAddress = "0x7518a73440e1B890b705cb260e47bc05E604F6b3"
		
		Symbol = "LAW";
		CoinDecimal = 18;
		ApprovingAddress = CoinAddress;
		CoinIsCLK = false;
		CoinIsCashCats = false;
		DisplayDigits = 4;
		CoinLogoURL = "../../image/"+Symbol.replace('$', 'CASH')+".png"
		return true;
	} else if(url.pathname.endsWith("/clk") || url.pathname.endsWith("/clk/") || url.pathname.endsWith("/clk/index.html")) {
		CoinAddress = ClkAddress;
		PoolAddress = "0xB9087049792B21d4F888c6918015440BB7b12300"
		
		Symbol = "CLK";
		CoinDecimal = 18;
		ApprovingAddress = CoinAddress;
		CoinIsCLK = true;
		CoinIsCashCats = false;
		DisplayDigits = 4;
		CoinLogoURL = "../../image/"+Symbol.replace('$', 'CASH')+".png"
		return true;
	}

	if(!url.searchParams.get("c")) {
		WarnText = "No coin specified"
		OpenWarnDlg = true
		return false
	}
	const coin = url.searchParams.get("c");
	const coinInfo = window.TOKENS[coin]
	//console.log("coinInfo", coinInfo)
	if(coinInfo === undefined) {
		WarnText = `Unknown Token: ${coin}`
		OpenWarnDlg = true
		return false
	}
	const factoryContract = new ethers.Contract(FactoryAddress, FactoryABI, provider);
	CoinAddress = coinInfo.address;
	CoinLogoURL = coinInfo.image;
	CoinIsCLK = CoinAddress == ClkAddress;
	CoinIsCashCats = CoinAddress == CashcatsAddress;
	const tokenContract = new ethers.Contract(CoinAddress, Erc20ABI, provider);
	Symbol = coinInfo.symbol; //await tokenContract.symbol();
	CoinDecimal = await tokenContract.decimals();
	DisplayDigits = (CoinDecimal < 6) ? CoinDecimal : 6;
	PoolAddress = await factoryContract.getPoolAddress(CoinAddress);
	//console.log("clkPool", await factoryContract.getPoolAddress(ClkAddress))
	//console.log("lawPool", await factoryContract.getPoolAddress("0x0b00366fBF7037E9d75E4A569ab27dAB84759302"))
	//console.log("bchPool", await factoryContract.getPoolAddress(BchAddress))
	//console.log("catsPool", await factoryContract.getPoolAddress(CashcatsAddress))
	//console.log("flexusdPool", await factoryContract.getPoolAddress("0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72"))
	//console.log("PoolAddress", PoolAddress)
	const code = await provider.getCode(PoolAddress, 0);
	//showNameAndSymbol(PoolAddress)
	if(code != "0x") {
		return true;
	}
	OpenCreateDlg = true;
	return false
}

async function createPool() {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const signer = provider.getSigner()
	const factoryContract = new ethers.Contract(FactoryAddress, FactoryABI, provider).connect(signer);
	const gas = await factoryContract.estimateGas.create(CoinAddress)
	//console.log("gas", gas, "CoinAddress", CoinAddress)
	const gasLimit = gas.mul(3).div(2)
	OpenWaitDialog = true
	WaitHintText = "Creating Pool...\nPlease wait for the transaction's execution result.";
	const tx = await factoryContract.create(CoinAddress, {gasLimit: gasLimit})
	const resp = await tx.wait()
	//console.log("create resp", resp)
	OpenWaitDialog = false
	OpenReloadDlg = true
}

function IsPC() {
       var userAgentInfo = navigator.userAgent;
       var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
       var flag = true;
       for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
             }
       }
       return flag;
}

function myAlert(text) {
	//console.log("myAlert ", text)
	WarnText = text
	OpenWarnDlg = true
}

async function connectWeb3() {
  const isPC = IsPC()
  //if(isPC) {
  //  document.getElementById("topLogo").style.display = "block";
  //}
  if (typeof window.ethereum === 'undefined') {
    if (typeof window.web3 !== 'undefined') {
      window.ethereum = window.web3;
    } else if (typeof window.TPJSBrigeClient !== 'undefined') {
      window.ethereum = window.TPJSBrigeClient;
    } else if (typeof window.imToken !== 'undefined') {
      window.ethereum = window.imToken;
    } else {
      const provider = await detectEthereumProvider();
      if (provider) {
        window.ethereum = provider;
      } else if(isPC) {
        myAlert("Your browser has not installed a wallet extension (like MetaMask).")
        return false;
      } else {
        myAlert("Please open this page inside a mobile wallet App.")
        return false;
      }
    }
  }
  window.accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
  if (window.accounts.length == 0) {
    myAlert("Cannot connect to wallet.")
    return false;
  }
  const chainId = await window.ethereum.request({method: 'eth_chainId'})
  if(chainId != SmartBCHChainId) {
    myAlert("You are not in smartBCH network.", chainId)
    return false;
  }
  return true;
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function formatTime(timestamp) {
  var date = new Date()
  date.setTime(timestamp)
  return date.toLocaleString('en-US', {
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).replace("24:", "00:")
}

function escapeHTML(s) {
  return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}

function myFormatUnits(v, digits, displayDigits) {
	if(!displayDigits) displayDigits = DisplayDigits;
	var n = ethers.utils.formatUnits(v, digits)*1.0;
	return n.toFixed(displayDigits)*1.0;
}

async function syncValues(autoFillAmount) {
  const div = (Multiplier < 3) ? 200.0 : 100.0
  MaxAmount = ((TotalCoins*0.98/Multiplier)/div).toFixed(DisplayDigits)*1.0
  //console.log("MaxAmount", MaxAmount)
  AmountWarn = ""
  if(Amount > MaxAmount) {
    if(autoFillAmount) {
      Amount = MaxAmount
    } else {
      AmountWarn = "> "+MaxAmount
    }
  }
  var chance = 100.0/Multiplier
  if(chance < 1) {
    chance = chance.toFixed(4)
  } else if(chance < 10) {
    chance = chance.toFixed(3)
  } else {
    chance = chance.toFixed(2)
  }
  Chance = chance;
  FeeAmount = (Amount*0.025).toFixed(DisplayDigits)*1.0
  RewardAmount = ((Amount-FeeAmount)*Multiplier).toFixed(DisplayDigits)*1.0

  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const clkContract = new ethers.Contract(ClkAddress, Erc20ABI, provider)

  var totalBurnt = await clkContract.balanceOf(BurnAddress)
  totalBurnt = myFormatUnits(totalBurnt, 18)

  var clkSupply = await clkContract.totalSupply()
  clkSupply = myFormatUnits(clkSupply, 18)
  ClkSupply = (clkSupply - totalBurnt).toFixed(4)
}

async function getInfo(poolContract, addr) {
  try {
    var [totalCoins, totalShare, userShare, lockUntil] = await poolContract.info(addr)
  } catch(e) {
    WarnText = "Cannot connect to RPC-Server!"
    OpenWarnDlg = true
  }
  TotalCoins = myFormatUnits(totalCoins, CoinDecimal)
  TotalShare = myFormatUnits(totalShare, ShareDecimal)
  UserShare = myFormatUnits(userShare, ShareDecimal)
  UserCoins = (TotalCoins*UserShare/TotalShare).toFixed(DisplayDigits)
  CoinPerShare = (TotalCoins/TotalShare).toFixed(DisplayDigits)
  UnlockTime = lockUntil
}

async function receivePendingReward() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  var [height, hash] = await poolContract.getLastTicketHeightAndHash() //TODO
  var res = await getBetaAndPI(hash, true);
  OpenWaitDialog = true
  WaitHintText = "Getting rewards...\nPlease wait for the transaction's execution result.";
  const tx = await poolContract.getMyReward("0x"+res.Beta, "0x"+res.PI);
  await tx.wait()
  OpenWaitDialog = false
}

async function watchCLK() {
  const ok = await ethereum.request({method: "wallet_watchAsset", params: {
    type: "ERC20",
    options: {
      address: ClkAddress,
      symbol: "CLK",
      decimals: 18,
      image: "https://catsluck.com/img/clk.png",
    },
  }})

  if(!ok) {
    WarnText = "Failed to make your wallet watch CLK."
    OpenWarnDlg = true
  }
}

async function watchFUN() {
  const ok = await ethereum.request({method: "wallet_watchAsset", params: {
    type: "ERC20",
    options: {
      address: FunAddress,
      symbol: "FUN",
      decimals: 18,
      image: "https://catsluck.com/img/fun.png",
    },
  }})

  if(!ok) {
    WarnText = "Failed to make your wallet watch FUN."
    OpenWarnDlg = true
  }
}

async function watchClkToken(symbol, address) {
  const ok = await ethereum.request({method: "wallet_watchAsset", params: {
    type: "ERC20",
    options: {
      address: PoolAddress,
      symbol: "clk"+Symbol,
      decimals: 18,
    },
  }})

  if(!ok) {
    WarnText = "Failed to make your wallet watch clk"+Symbol+"."
    OpenWarnDlg = true
  }
}

async function watchCATSUP() { //TODO
  const ok = await ethereum.request({method: "wallet_watchAsset", params: {
    type: "ERC20",
    options: {
      address: CatsupAddress,
      symbol: "CATSUP",
      decimals: 18,
      image: "https://catsluck.com/img/catsup.png",
    },
  }})

  if(!ok) {
    WarnText = "Failed to make your wallet watch CATSUP."
    OpenWarnDlg = true
  }
}

async function checkVrfServers(provider) {
	const vrfgovContract = new ethers.Contract(VrfGovAddress, VrfGovABI, provider)
	const onchainKey = await vrfgovContract.pubKey()
	try {
		const resp0 = await fetchWithTimeout("https://enclave0.vrf.cash:8081/pubkey")
		const key0 = await resp0.text()
		if(onchainKey == "0x"+key0) {
			VrfServers = ["enclave0.vrf.cash:8081", ...VrfServers]
		}
	} catch(e) {
		console.log("Failed to connect enclave0.vrf.cash", e)
	}
	try {
		const resp1 = await fetchWithTimeout("https://enclave1.vrf.cash:8081/pubkey")
		const key1 = await resp1.text()
		if(onchainKey == "0x"+key1) {
			VrfServers = ["enclave1.vrf.cash:8081", ...VrfServers]
		}
	} catch(e) {
		console.log("Failed to connect enclave1.vrf.cash", e)
	}
	console.log("VRF Servers:", VrfServers)
}

async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 3000 } = options;
  
  const abortController = new AbortController();
  const id = setTimeout(() => abortController.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: abortController.signal  
  });
  clearTimeout(id);
  return response;
}

async function getBetaAndPI(hashBN, showVRFHintDialog) {
  const hashHex = ethers.utils.hexZeroPad(hashBN.toHexString(), 32).substr(2)
  const servers = VrfServers;
  var idx = (Math.random() > 0.5) ? 1 : 0;
  if(showVRFHintDialog) {
    OpenWaitDialog = true;
    WaitHintText = "Connecting to the VRF server..."
  }
  for(var i=idx; i<3; i++) {
    var j = i%servers.length;
    try {
      const url = "https://"+servers[j]+"/vrf?b="+hashHex
      console.log("server", servers[j], j, url, hashHex)
      const response = await fetchWithTimeout(url)
      var result = await response.json();
      console.log(result);
      if(result.PI) {
        OpenWaitDialog = false;
        return result;
      }
    } catch(e) {
      console.log("continue", e);
      continue
    }
  }
  OpenWaitDialog = false;
  WarnText = "Invalid VRF result:"+result
  OpenWarnDlg = true;
  return {}
}

var VRFHintDialogShown = false

async function queryMyReward(poolContract, showVRFHintDialog) {
	//console.log("HH1");
	var [height, hash] = await poolContract.getLastTicketHeightAndHash();
	const currHeight = await poolContract.provider.getBlockNumber()
	height = height.toNumber()
	//console.log("HH2", height, currHeight);
	if(height + 256 < currHeight || height == 0) {
		return ethers.BigNumber.from(0);
	}
	if(hash.isZero()) return AllOnes;
	VRFHintDialogShown = true
	var res = await getBetaAndPI(hash, showVRFHintDialog);
	var reward = await poolContract.callStatic.getMyReward("0x"+res.Beta, "0x"+res.PI);
	return reward;
}

async function init() {
  document.getElementById("gtrans").setAttribute("src", "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2")

  const url = new URL(location.href);
  if(url.hash == "#pool") {
    active = "POOL"
  } else if(url.hash == "#faq") {
    active = "FAQ"
  }
  //console.log("hash", url.hash, active)

  //console.log("Here")
  if(!connectWeb3()) return
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  await saveReferer(provider)
  const ok = await fillCoinInfo(provider);
  if(!ok) return;

  await checkVrfServers(provider)

  document.title = Symbol+" Pool"
  //console.log("Here0")
  const signer = provider.getSigner()
  const signerAddr = await signer.getAddress()
  SignerAddr = signerAddr
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  await getInfo(poolContract, signerAddr)
  await syncValues(true)
  window.setInterval(async function() {await syncValues(false);}, 10000)

  //console.log("Here1")
  var reward  = await queryMyReward(poolContract) //TODO
  //console.log("Here2")
  showAndUpdateHistoryTable()
  for(var i=0; i<30 && reward.eq(AllOnes); i++) { // wait until the block hash is available
    await sleep(2000)
    reward = await queryMyReward(poolContract) //TODO
  }
  if(!reward.isZero() && !reward.eq(AllOnes)) {
    PendingRewardAmount = myFormatUnits(reward, CoinDecimal)
    OpenPendingRewardDlg = true
  }

  const referContract = new ethers.Contract(FactoryAddress, ReferBookABI, provider)
  //console.log(await referContract.getAllReferers())
  //console.log(await referContract.referers(0))
  ReferID = await referContract.referer2Id(signerAddr)
  ReferReward = myFormatUnits(await poolContract.referRewards(SignerAddr), CoinDecimal)
  CoinReadyForAuction = myFormatUnits(await poolContract.buybackPoolSize(), CoinDecimal);
  const startTime = await poolContract.auctionStartTime();
  DuringAuction = startTime != 0;
  if(DuringAuction) {
    const res = await poolContract.getAuctionTokensAndPrice();
    //console.log("Here4", res[0])
    ClkOfAuction = myFormatUnits(res[0], 18, 10);
    CoinOfAuction = myFormatUnits(res[1], CoinDecimal);
    PriceOfAuction = myFormatUnits(res[2], 18, 4);
    if(CoinDecimal < 18) {
      PriceOfAuction = PriceOfAuction/Math.pow(10, 18-CoinDecimal)
    } else if(CoinDecimal < 18) {
      PriceOfAuction = PriceOfAuction*Math.pow(10, CoinDecimal-18)
    }
  }
  var oldCountLimit = localStorage.getItem("recCountLimit")
  if(oldCountLimit) {
    RecCountLimit = oldCountLimit
  }
}

async function approve() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const tokenContract = new ethers.Contract(ApprovingAddress, Erc20ABI, provider).connect(signer)
  await tokenContract.approve(PoolAddress, ethers.utils.parseUnits("1", 28))
}

async function buy() {
  syncValues(false)
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)

  VRFHintDialogShown = false
  var reward  = await queryMyReward(poolContract, true) //TODO
  for(var i=0; i<30 && reward.eq(AllOnes); i++) { // wait until the block hash is available
    //console.log(reward)
    await sleep(2000)
    reward = await queryMyReward(poolContract) //TODO
  }
  if(!reward.isZero() && !reward.eq(AllOnes)) {
    PendingRewardAmount = myFormatUnits(reward, CoinDecimal)
    OpenPendingRewardDlg = true
    return
  }
  if(!VRFHintDialogShown) {
    const height = await provider.getBlockNumber()
    const blk = await provider.getBlock(height-100)
    const result = await getBetaAndPI(ethers.BigNumber.from(blk.hash), true)
    if(!result.PI) {
      WarnText = "Cannot connect to VRF servers!"
      OpenWarnDlg = true
      return
    }
  }

  const tokenContract = new ethers.Contract(CoinAddress, Erc20ABI, provider).connect(signer)
  if(Amount > MaxAmount) {
    WarnText = `The amount ${Amount} is larger than the maximum amount you can buy (${MaxAmount})!`
    OpenWarnDlg = true
    return
  }
  const signerAddr = await signer.getAddress()
  const balanceBN = await tokenContract.balanceOf(signerAddr)
  const balance = myFormatUnits(balanceBN, CoinDecimal)
  if(balance < Amount) {
    WarnText = `You balance (${balance}) is less than the amount (${Amount}) you want to pay!`
    OpenWarnDlg = true
    return
  }
  if(CoinAddress != BchAddress) {
    const allowanceBN = await tokenContract.allowance(signerAddr, PoolAddress)
    const allowance = myFormatUnits(allowanceBN, CoinDecimal)
    //console.log("HH", allowance, Amount, CoinAddress, allowanceBN)
    if(allowance < Amount) {
      HintText = "You have not approved enough allowance to this lottery contract. Please appove and retry buying."
      ApprovingAddress = CoinAddress
      OpenApproveDlg = true
      return
    }
  }
  const catsluckContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  const amountBN = ethers.utils.parseUnits((Amount*1.0).toFixed(CoinDecimal), CoinDecimal)
  const multiplierX100 = (Multiplier*100).toFixed(0)
  if(multiplierX100 < 105 || multiplierX100 > 100000) {
    WarnText = "The multiplier is invalid. It must be within the range [1.05, 1000]."
    OpenWarnDlg = true
    return
  }
  var referer = localStorage.getItem("referer");
  if(!referer) {
    referer = ZeroAddress;
  }
  var args = {gasPrice: DefaultGasPrice}
  if(CoinAddress == BchAddress) {
    args["value"] = amountBN
  }
  //console.log("referer", referer)
  OpenWaitDialog = true
  WaitHintText = "Buying...\nPlease wait for the transaction's execution result.";
  //console.log("HHH", amountBN)
  const tx = await catsluckContract.buyLottery(amountBN, multiplierX100, referer, args)
  await tx.wait()
  var reward = await queryMyReward(poolContract)
  while(reward.eq(AllOnes)) { // wait until the block hash is available
    await sleep(2000)
    reward = await queryMyReward(poolContract)
  }
  OpenWaitDialog = false
  if(reward.isZero()) {
    OpenNoRewardDlg = true
    return
  }
  OpenYesRewardDlg = true
  return
}

async function deposit() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const tokenContract = new ethers.Contract(CoinAddress, Erc20ABI, provider).connect(signer)
  const signerAddr = await signer.getAddress()
  const balanceBN = await tokenContract.balanceOf(signerAddr)
  const balance = myFormatUnits(balanceBN, CoinDecimal)
  //console.log("balance", balance)
  if(balance < DepositAmount) {
    WarnText = `You balance (${balance}) is less than the amount (${DepositAmount}) you want to deposit!`
    OpenWarnDlg = true
    return
  }
  if(CoinAddress != BchAddress) {
    const allowanceBN = await tokenContract.allowance(signerAddr, PoolAddress)
    const allowance = myFormatUnits(allowanceBN, CoinDecimal)
    //console.log("allowance", allowance)
    if(allowance < DepositAmount) {
      HintText = "You have not approved enough allowance to this lottery contract. Please appove and retry to deposit."
      ApprovingAddress = CoinAddress
      OpenApproveDlg = true
      return
    }
  }
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  const depositAmountBN = ethers.utils.parseUnits((DepositAmount*1.0).toFixed(CoinDecimal), CoinDecimal)
  //console.log("DepositAmount", DepositAmount, CoinDecimal, depositAmountBN.toHexString())
  var args = {gasPrice: DefaultGasPrice}
  if(CoinAddress == BchAddress) {
    args["value"] = depositAmountBN
  }
  OpenWaitDialog = true
  WaitHintText = "Depositing...\nPlease wait for the transaction's execution result.";
  const tx = await poolContract.deposit(depositAmountBN, 0, args)
  const resp = await tx.wait()
  //console.log("deposit resp", resp)
  OpenWaitDialog = false
  OpenReloadDlg = true
}

async function withdraw() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  //console.log("HereC")
  if(UnlockTime > Date.now()/1000) {
    const depositTime = formatTime(1000*(UnlockTime-3600))
    const unlockTime = formatTime(1000*UnlockTime)
    WarnText = `You just deposit some coins at ${depositTime}, now your coins are locked. Please retry after ${unlockTime}`
    OpenWarnDlg = true
    return
  }
  //console.log("HereD")
  if(UserCoins*1.15 < WithdrawAmount) { // WithdrawAmount is too big
    WarnText = `The value you want withdraw (${WithdrawAmount}) is larger than the maximum possible value (${UserCoins}).`
    OpenWarnDlg = true
    return
  }
  var withdrawShare = UserShare // default is full withdraw
  if(UserCoins*1.0 > WithdrawAmount/*partial withdraw*/) {
    withdrawShare = UserShare * WithdrawAmount / UserCoins
  }
  if(withdrawShare > UserShare) {
    withdrawShare = UserShare
  }
  //console.log("HereE")
  const withdrawShareBN = ethers.utils.parseUnits((withdrawShare*1.0).toFixed(ShareDecimal), ShareDecimal)
  OpenWaitDialog = true
  WaitHintText = "Withdrawing...\nPlease wait for the transaction's execution result.";
  const tx = await poolContract.withdraw(withdrawShareBN, {gasPrice: DefaultGasPrice})
  const resp = await tx.wait()
  //console.log("withdraw resp", resp)
  OpenWaitDialog = false
  OpenReloadDlg = true
}

async function showMyHistory() {
  //console.log("here!")
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const signerAddr32 = ethers.utils.hexZeroPad(await signer.getAddress(), 32)
  var filter = {address: PoolAddress, topics: [[Deposit, Withdraw], signerAddr32]}
  var toHeight = await provider.getBlockNumber()
  //console.log("here!!", filter, DefaultGasPrice, toHeight)
  filter.fromBlock = DefaultStartHeight
  filter.toBlock = toHeight
  var logs = await provider.getLogs(filter)
  //console.log("here2!!", logs)
  showPoolOperations(logs)
}

async function fetchLogs(startHeight, toHeight, provider, filter, countLimit, step) {
  var allLogs = []
  while(toHeight > startHeight) {
    filter.fromBlock = Math.max(toHeight-step+1, startHeight)
    filter.toBlock = toHeight
    var logs = await provider.getLogs(filter)
    //console.log("aaa ", filter.fromBlock, filter.toBlock, logs.length)
    for(var i=logs.length-1; i>=0; i--) {
      //console.log("bnumber ", logs[i].blockNumber)
      allLogs.unshift(logs[i])
    }
    if(allLogs.length > countLimit) {
      break
    }
    toHeight -= step
    if(logs.length < 10000) {//try larger step
      step = step * 2
    }
  }
  return allLogs
}

function showPoolOperations(logs) {
  var poolHisEntries = []
  var totalInvest = 0
  for(var i=0; i<logs.length; i++) {
    var log = logs[i]
    const timestamp = ethers.BigNumber.from("0x"+log.data.substr(2+24+24))
    const timeStr = formatTime(1000*timestamp.toNumber())
    if(log.topics[0] == Deposit || log.topics[0] == Withdraw) {
      var entry = {timeStr}
      const amountBN = ethers.BigNumber.from(log.data.substr(0, 2+24))
      entry.amount  = myFormatUnits(amountBN, CoinDecimal)
      entry.isDeposit = log.topics[0] == Deposit
      entry.isWithdraw = log.topics[0] == Withdraw
      if(log.topics[0] == Deposit) {
        totalInvest += entry.amount*1.0
      } else if(log.topics[0] == Withdraw) {
        totalInvest -= entry.amount*1.0
      }
      entry.transactionHash = log.transactionHash
      poolHisEntries.push(entry)
    }
  }
  PoolHisEntries = poolHisEntries
  //var totalEarning = UserCoins - totalInvest
  //TotalEarning = totalEarning.toFixed(DisplayDigits)
  ShowPoolTable = true
}

async function showHistoryTable(startHeight, toHeight, provider) {
  var filter = {address: PoolAddress, topics: [[Win, Buy]]}
  var addr = SignerAddr
  if(OnlyMyLottery) {
    const signer = provider.getSigner()
    console.log("AddrForHistory", AddrForHistory)
    if(AddrForHistory) {
      addr = AddrForHistory
    }
    try {
      ethers.utils.getAddress(addr)
    } catch(e) {
      WarnText = "Invalid Address: "+ addr
      OpenWarnDlg = true
      return
    }
    const signerAddr32 = ethers.utils.hexZeroPad(addr, 32)
    filter.topics.push(signerAddr32)
  }
  //console.log("OnlyMyLottery", OnlyMyLottery, addr, filter)
  var step = OnlyMyLottery? 100000 : 30000
  var logs = await fetchLogs(startHeight, toHeight, provider, filter, RecCountLimit, step)
  //console.log("logs", logs)
  var start = Math.max(logs.length-RecCountLimit, 0)
  var entryList = []
  for(var i=start; i<logs.length; i++) {
    var log = logs[i]
    const timestamp = ethers.BigNumber.from("0x"+log.data.substr(2+24+24))
    const timeStr = formatTime(1000*timestamp.toNumber())
    var entry = {timeStr}
    if(log.topics[0] == Win || log.topics[0] == Buy) {
      const amountBN = ethers.BigNumber.from(log.data.substr(0, 42))
      entry.amount  = myFormatUnits(amountBN, CoinDecimal)
      const multiplierBN = ethers.BigNumber.from("0x"+log.data.substr(42, 8))
      entry.multiplier = ethers.utils.formatUnits(multiplierBN, 2)
      entry.isWin = log.topics[0] == Win
      entry.isBuy = log.topics[0] == Buy
      if(entry.isWin) {
        TotalWon += entry.amount
      } else if(entry.isBuy) {
        TotalBought += entry.amount
      }
    }
    entry.transactionHash = log.transactionHash
    entry.id = log.transactionHash+"-"+log.logIndex
    if(!LogIdSet.has(entry.id)) {
      entryList.unshift(entry)
      LogIdSet.add(entry.id)
    }
  }
  HistoryEntries = [].concat(entryList, HistoryEntries)
  ShowHistoryTable = true
  //console.log("HistoryEntries", HistoryEntries)
  ROI = (TotalWon*100/TotalBought).toFixed(2)
}

function showHistoryTableOfAddr() {
    try {
      ethers.utils.getAddress(SpecifiedAddr)
    } catch(e) {
      WarnText = "Invalid Address: "+ SpecifiedAddr
      OpenWarnDlg = true
      return
    }
    OnlyMyLottery = true
    AddrForHistory = SpecifiedAddr
    showAndUpdateHistoryTable()
}

async function showAndUpdateHistoryTable() {
  clearInterval(window.tableUpdateInterval)
  HistoryEntries = []
  //console.log("Now clear HistoryEntries", HistoryEntries)
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  window.latestHeight4HisTbl = await provider.getBlockNumber()
  TotalWon = 0
  TotalBought = 0
  LogIdSet = new Set()
  await showHistoryTable(DefaultStartHeight, window.latestHeight4HisTbl, provider)
  window.tableUpdateInterval = setInterval(async function() {
    var newHeight = await provider.getBlockNumber()
    if(window.latestHeight4HisTbl+1 <= newHeight) {
      await showHistoryTable(window.latestHeight4HisTbl+1, newHeight, provider)
    }
    window.latestHeight4HisTbl = newHeight
  }, 10000)
}
  
function changeShownRecCount() {
    if(RecCountLimit<20) {
    	RecCountLimit = 20
    }
    if(RecCountLimit>500) {
    	RecCountLimit = 500
    }
    localStorage.setItem("recCountLimit", RecCountLimit)
}

async function showPoolHistory() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const signerAddr = await signer.getAddress()
  const poolContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  await getInfo(poolContract, signerAddr)
  await syncValues(false)
  await showMyHistory()
}

function onFilterMethodChange() {
  if(FilterMethod == OldFilterMethod) {
    return
  }
  OldFilterMethod = FilterMethod
  //console.log("onFilterMethodChange", FilterMethod)
  if(FilterMethod == "All") {
    OnlyMyLottery = false
    AddrForHistory = null
    showAndUpdateHistoryTable()
  } else if(FilterMethod == "Mine") {
    OnlyMyLottery = true
    AddrForHistory = null
    HistoryEntries = []
    showAndUpdateHistoryTable()
  } else if(FilterMethod=="Specified") {
    OpenAddressDlg = true
  }
}

async function mintFUN() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const tokenContract = new ethers.Contract(FunAddress, Erc20ABI, provider).connect(signer)
  await tokenContract.mint()
}

async function registerAsReferer() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const referContract = new ethers.Contract(FactoryAddress, ReferBookABI, provider).connect(signer)
  OpenWaitDialog = true
  WaitHintText = "Registering...\nPlease wait for the transaction's execution result.";
  const tx = await referContract.registerAsReferer()
  await tx.wait()
  OpenWaitDialog = false
  OpenReloadDlg = true
}

async function getRefererReward() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const catsluckContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  OpenWaitDialog = true
  WaitHintText = "Getting rewards...\nPlease wait for the transaction's execution result.";
  const tx = await catsluckContract.getRefererReward()
  await tx.wait()
  OpenWaitDialog = false
  OpenReloadDlg = true
}

async function startAuction() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const catsluckContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  OpenWaitDialog = true
  WaitHintText = "Starting the auction...\nPlease wait for the transaction's execution result.";
  const tx = await catsluckContract.startDutchAuction()
  await tx.wait()
  OpenWaitDialog = false
  OpenReloadDlg = true
}

async function endAuction() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()

  const tokenContract = new ethers.Contract(ClkAddress, Erc20ABI, provider).connect(signer)
  const allowanceBN = await tokenContract.allowance(SignerAddr, PoolAddress)
  if(allowanceBN.lt(ethers.utils.parseUnits("1", 26))) {
    HintText = "You have not approved enough CLK to this lottery contract. Please appove and retry."
    ApprovingAddress = ClkAddress
    OpenApproveDlg = true
    return
  }

  const balanceBN = await tokenContract.balanceOf(SignerAddr)
  const balance = myFormatUnits(balanceBN, 18)
  //console.log("HERE", balanceBN, balance, ClkOfAuction)
  if(balance < ClkOfAuction) {
    WarnText = `You balance (${balance}) is less than the amount (${ClkOfAuction}) you need to pay for the auction!`
    OpenWarnDlg = true
    return
  }

  const catsluckContract = new ethers.Contract(PoolAddress, ABI, provider).connect(signer)
  OpenWaitDialog = true
  WaitHintText = "Please wait for the transaction's execution result.";
  const tx = await catsluckContract.endDutchAuction()
  await tx.wait()
  OpenWaitDialog = false
  OpenReloadDlg = true
}

/** DEPLOY
async function deployToken(symbol) {
  const abi = [ "constructor(string memory name_, string memory symbol_) public" ];
  const bytecode = "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"
  
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  try {
    const signer = provider.getSigner()
    const factory = new ethers.ContractFactory(abi, bytecode, signer)
    const contract = await factory.deploy(symbol, symbol);
    console.log("address:", contract.address)
    const receipt = await contract.deployTransaction.wait();
    console.log(receipt)
  } catch(e) {
    alert("Error! "+e.toString())
  }
}

async function deploy(bytecode) {
  const abi = [ "constructor() public" ];
  
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  try {
    const signer = provider.getSigner()
    const factory = new ethers.ContractFactory(abi, bytecode, signer)
    const contract = await factory.deploy();
    console.log("address:", contract.address)
    const receipt = await contract.deployTransaction.wait();
    console.log(receipt)
  } catch(e) {
    alert("Error! "+e.toString())
  }
}

async function deployGov() {
  deploy("0x608060405234801561001057600080fd5b506101e3806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063ac2a5dfd1461003b578063b857e38614610077575b600080fd5b610061604080516001602082015260609101604051602081830303815290604052905090565b60405161006e91906100b2565b60405180910390f35b61008a610085366004610107565b61009a565b604051901515815260200161006e565b6000836100a8866001610187565b1495945050505050565b600060208083528351808285015260005b818110156100df578581018301518582016040015282016100c3565b818111156100f1576000604083870101525b50601f01601f1916929092016040019392505050565b6000806000806060858703121561011d57600080fd5b8435935060208501359250604085013567ffffffffffffffff8082111561014357600080fd5b818701915087601f83011261015757600080fd5b81358181111561016657600080fd5b88602082850101111561017857600080fd5b95989497505060200194505050565b600082198211156101a857634e487b7160e01b600052601160045260246000fd5b50019056fea2646970667358221220016e472ef331e98dad093abe09cdeb21ed95efe9b3e5b7fac17b95b6d7ea500164736f6c634300080a0033")
}

async function deployCatsUp() {
  deploy("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")
}

async function deployFactory() {
  deploy("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")
}

async function createCatsPool() {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const signer = provider.getSigner()
	const factoryContract = new ethers.Contract(FactoryAddress, FactoryABI, provider).connect(signer);
	const addr = await factoryContract.getPoolAddress(CashcatsAddress)
	console.log("to create: ", addr)
	const tx = await factoryContract.create(CashcatsAddress)
	const resp = await tx.wait()
	console.log(resp)
}

async function createBchPool() {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const signer = provider.getSigner()
	const factoryContract = new ethers.Contract(FactoryAddress, FactoryABI, provider).connect(signer);
	const addr = await factoryContract.getPoolAddress(BchAddress)
	console.log("to create: ", addr)
	const tx = await factoryContract.create(BchAddress)
	const resp = await tx.wait()
	console.log(resp)
}

async function createFlexusdPool() {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const signer = provider.getSigner()
	const factoryContract = new ethers.Contract(FactoryAddress, FactoryABI, provider).connect(signer);
	const flexusd = "0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72"
	const addr = await factoryContract.getPoolAddress(flexusd)
	console.log("to create: ", addr)
	const tx = await factoryContract.create(flexusd)
	const resp = await tx.wait()
	console.log(resp)
}

async function showTwoNameAndSymbol() {
	await showNameAndSymbol("");
	await showNameAndSymbol("");
}

async function showNameAndSymbol(poolAddress) {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const poolContract = new ethers.Contract(poolAddress, Erc20ABI, provider)
	console.log(await poolContract.name())
	console.log(await poolContract.symbol())
}

async function setMinter() {
	const provider = new ethers.providers.Web3Provider(window.ethereum)
	const signer = provider.getSigner()
	const abi = ["function setMinter(address account) public"]
	const catsupContract = new ethers.Contract(CatsupAddress, abi, provider).connect(signer)
	console.log("pooladdress", "0x9343763BF4092a825564fB3D14DC0ab2dbFB1e16")
	const tx = await catsupContract.setMinter("0x9343763BF4092a825564fB3D14DC0ab2dbFB1e16")
	const resp = await tx.wait()
	console.log(resp)
}
*/

</script>
